export default __webpack_public_path__ + "static/kindergarten-readiness8-129b2b0748a6a0a19166e25e1446f057.jpg";